document.addEventListener("DOMContentLoaded", () => {
    AFRAME.registerComponent("wasd-to-analog2d", {
        schema: {
            analog2dOutputAction: {
                default: "wasd_analog2d",
            },
        },
        init: function () {
            this.output = [0, 0];
            this.vectors = {
                w: [0, 1],
                a: [-1, 0],
                s: [0, -1],
                d: [1, 0],
            };
            this.keys = {};
            this.onWasd = this.onWasd.bind(this);
            this.move = this.move.bind(this);
            this.onBlur = this.onBlur.bind(this);
            this.el.sceneEl.addEventListener("enter-vr", () => this.pause());
            this.el.sceneEl.addEventListener("exit-vr", () => this.play());
        },
        play: function () {
            const events = [
                "w_down",
                "w_up",
                "a_down",
                "a_up",
                "s_down",
                "s_up",
                "d_down",
                "d_up",
            ];
            for (const event of events) {
                this.el.sceneEl.addEventListener(event, this.onWasd);
            }
            this.el.sceneEl.addEventListener(
                this.data.analog2dOutputAction,
                this.move
            );
            window.addEventListener("blur", this.onBlur);
        },
        pause: function () {
            this.el.sceneEl.removeEventListener("wasd", this.onWasd);
            this.el.sceneEl.removeEventListener(
                this.data.analog2dOutputAction,
                this.move
            );
            window.removeEventListener("blur", this.onBlur);
            this.keys = {};
        },
        onBlur: function () {
            this.keys = {};
        },
        move: function (event) {
            if (event.detail.axis !== [0, 0]) {
                this.el.emit("move", {
                    axis: event.detail.axis,
                });
            }
        },
        onWasd: function (event) {
            const type = event.type;
            const isKeyDown = type.includes("down");
            const key = type[0].toLowerCase();
            this.keys[key] = isKeyDown;
        },
        tick: function () {
            this.target = [0, 0];
            for (const key in this.keys) {
                if (this.keys[key] && this.vectors[key]) {
                    this.target = [
                        this.target[0] + this.vectors[key][0],
                        this.target[1] + this.vectors[key][1],
                    ];
                }
            }
            const length = Math.sqrt(
                this.target[0] * this.target[0] +
                    this.target[1] * this.target[1]
            );
            if (length !== 0) {
                this.target[0] = this.target[0] / length;
                this.target[1] = this.target[1] / length;
            }
            if (this.target[0] !== 0 || this.target[1] !== 0) {
                this.el.emit(this.data.analog2dOutputAction, {
                    axis: this.target,
                });
            }
        },
    });
});
